'use client'

import { accordionProcessor } from './accordion-processor'
import { tabMenuProcessor } from './tab-menu-processor'

export interface PostProcessor {
  (node: Element): void
}

// add processors here
const processors = [tabMenuProcessor, accordionProcessor]

export const postProcessor: PostProcessor = node => {
  for (let i = 0; i < processors.length; i++) {
    processors[i]?.(node)
  }
}
